import {Component} from '@angular/core';
import {ApiService} from '../../services';


@Component({
    selector: 'export',
    template: require('./export.component.html'),
    styles: [require('./export.component.scss')]
})
export class ExportComponent {

    constructor(private api: ApiService) {

    }

    export() {
        this.api.downloadWithTempToken('export/clients', true);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/export/export.component.ts